import { render } from "./DocumentDetailOlapDesignerDialog.vue?vue&type=template&id=d598ddee&ts=true"
import script from "./DocumentDetailOlapDesignerDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentDetailOlapDesignerDialog.vue?vue&type=script&lang=ts"

import "./DocumentDetailOlapDesignerDialog.vue?vue&type=style&index=0&id=d598ddee&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__